var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbArrowMaximize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2a1 1 0 011-1h4a1 1 0 010 2H4.414l3.293 3.293a1 1 0 01-1.414 1.414L3 4.414V6a1 1 0 01-2 0V2zm13-1h4a1 1 0 011 1v4a1 1 0 11-2 0V4.414l-3.293 3.293a1 1 0 11-1.414-1.414L15.586 3H14a1 1 0 110-2zM7.707 12.293a1 1 0 010 1.414L4.414 17H6a1 1 0 110 2H2a1 1 0 01-1-1v-4a1 1 0 112 0v1.586l3.293-3.293a1 1 0 011.414 0zm4.586 0a1 1 0 011.414 0L17 15.586V14a1 1 0 112 0v4a1 1 0 01-1 1h-4a1 1 0 110-2h1.586l-3.293-3.293a1 1 0 010-1.414z",
    fill: "#111"
  })));
}

export default SvgIbArrowMaximize;